module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitlea",
    attrs: {
      "id": "tex"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('strong', [_vm._v("A Note on the Text")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the interests of clarity for the reader, in the following pages I use the traditional Roman numeral styles of reference for Federal Army corps (e.g. I Corps, II Corps, etc.) and the plain English for Confederate army corps (First Corps, Second Corps, etc.) so that a simple glance may be enough for the reader to ascertain which side a particular corps belongs to. I have also chosen to employ the name “Federal” as opposed to “Union” to refer to troops of the United States Army for the purposes of delineation between the war aim of the preservation of the Union and the armies of the United States government. For each chapter of this work, I have chosen for an epigraph lyrics from songs contemporaneous to the era and applicable to the subject matter of the various chapters (exempting the introduction and the appendix), in the name of thematic consistency, and to provide readers with a taste of the culture of the nation as directly related to the ongoing Civil War.")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("In the Army of the Union, if they post us in the van,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We’ll clear the way before, if the bravest soldiers can;")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We will drive the rebel forces from their strongholds to the sea,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("And will live and die together, in the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("The army of the free, the army of the free,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We will live and die together, in the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We may rust beneath inaction, we may sink beneath disease,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("The summer sun may scorch us, or the winter’s blasts may freeze,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("But whatever may befall us, we will let the rebels see,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("That unconquered, we shall still remain the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We are proud of our Division, ’mid a half a million souls,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("And only resting on our arms till the war-cry onward rolls;")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("When our gallant General Porter calls, why ready we shall be,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("To follow him forever, with the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("Though we live in winter quarters now, we’re waiting but the hour,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("When Porter’s brave Division shall go forth in all its power,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("And when on the field of battle, fighting we shall be,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("We’ll swear that no disgrace shall stain the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("Then hurrah for our Division, may it soon be called to go,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("To strengthen our brave brothers who have marched to meet the foe;")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("God bless it, for we know right well, wherever it may be,")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote-c"
  }, [_vm._v("’Twill try to add new lustre to the army of the free.")])]), _vm._v(" "), _c('div', {
    staticClass: "block1"
  }, [_c('p', {
    staticClass: "blockquote-r"
  }, [_c('em', [_vm._v("Porter’s Division Song (The Army of the Free)")]), _c('br'), _vm._v("Frank H. Norton, c. 1862"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/21_notes#texfn1",
      "id": "rtexfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c68d478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_text.vue
// module id = 81
// module chunks = 0